{
  "name": "@pixel_nomad/shoukaku",
  "version": "4.1.22",
  "description": "A stable and updated wrapper around Lavalink",
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.js"
    }
  },
  "scripts": {
    "build": "npm run build:ts && npm run build:docs",
    "build:ts": "tsup --config tsup-config.json",
    "build:docs": "typedoc --theme default --readme README.md --out docs/ --entryPointStrategy expand src/.",
    "lint": "eslint .",
    "prepare": "npm run build:ts",
	"update" : "npm run build && npm publish --access public"
  },
  "keywords": [
    "bot",
    "music",
    "lavalink",
    "api",
    "discord",
    "lavalink.js",
    "discord.js",
    "lavalink-api",
    "weeb-library"
  ],
  "engines": {
    "node": ">=18.0.0",
    "npm": ">=7.0.0"
  },
  "author": "Saya",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/Pixel-Nomad/Shoukaku.git"
  },
  "dependencies": {
    "ws": "^8.18.0"
  },
  "devDependencies": {
    "@shipgirl/eslint-config": "^0.2.2",
    "@types/node": "^22.2.0",
    "@types/ws": "^8.5.12",
    "eslint": "^9.9.0",
    "tsup": "^8.2.4",
    "typedoc": "^0.26.5",
    "typescript": "^5.5.4"
  }
}
